// src/components/Ion.tsx
import React from 'react';

/** Props para el wrapper del web component <ion-icon> */
export type IonProps = React.HTMLAttributes<HTMLElement> & {
  /** Nombre del icono, ej.: "home-outline" */
  name: string;
  /** Clases CSS opcionales */
  className?: string;
};

/**
 * Componente seguro y ligero para usar Ionicons en React.
 * 
 * ✅ Ejemplo:
 * ```tsx
 * <Ion name="notifications-outline" className="me-2 text-primary" />
 * ```
 * 
 * Internamente usa React.createElement para evitar errores de tipo JSX,
 * y asegura compatibilidad con los web components nativos de Ionicons.
 */
const IonBase: React.FC<IonProps> = ({ name, className, ...rest }) => {
  return React.createElement('ion-icon', {
    name,
    class: className,       // necesario para el custom element
    className,              // mantiene compatibilidad React
    ...rest,
  });
};

// React.memo previene renders innecesarios en layouts grandes
const Ion = React.memo(IonBase);

export { Ion };
export default Ion;
